module.exports = __webpack_public_path__ + "img/unifacs.2013563b.svg";